/**
 * This should correspond to the Java class au.com.finsyn.acuritywebserver.core.api.InsertResult
 * Do not change properties and keep them synchronized with backend class
 */
export interface InsertResult {
	id: number;
	warningMessages?: string[];
}

export function isInsertResult(object: any): object is InsertResult {
	return 'id' in object && typeof object.id === 'number';
}
